<template>
  <content-box class="popup__content"
               :class="{'is-done': isDoneResetPassword, 'error': authParam.value !== 'key'}"
               :width="'430px'"
               :isDimmedContent="true">
    <template v-if="!isDoneResetPassword">
      <div v-if="authParam.key === 'key'" class="auth-success">
        <i class="icon icon--reset-password"></i>
        <strong class="title">{{ $t('account.resetPassword.title') }}</strong>
        <div class="input--wrap">
          <form @submit.prevent="onSubmit">
            <fieldset>
              <label class="label" for="resetPassword">{{ $t('common.newPassword') }}</label>
              <input id="resetPassword"
                     type="password"
                     v-model="model.userPw"
                     autocomplete="on"
                     :placeholder="$t('common.placeHolder.enter6char')"
                     @focus="modelError.userPw = ''">
              <i class="icon icon--pw-eye"
                 :class="{on: !toggleInputType}"
                 @click="toggleShowPasswordValue"></i>
              <strong v-if="modelError.userPw" class="validation-text">
                {{ $t(`common.validationErrorText.${modelError.userPw}`) }}
              </strong>
            </fieldset>
            <div class="btn--wrap">
              <UiButton :buttonType="'reset'" @click="onCloseLayer">
                {{ $t('common.cancel') }}
              </UiButton>
              <UiButton class="btn__confirm" :buttonType="'submit'" :primary2="true">
                {{ $t('common.confirm') }}
              </UiButton>
            </div>
          </form>
        </div>
      </div>

      <div v-else class="auth-fail">
        <i class="icon icon--alert-size50"></i>
        <p class="title">{{ $t('account.resetPassword.expired.title') }}</p>
        <p class="desc" v-html="$t('account.resetPassword.expired.desc')"></p>
        <UiButton class="btn__confirm" @click="onCloseLayer">
          {{ $t('common.confirm') }}
        </UiButton>
      </div>
    </template>

    <div v-else class="reset-password__done">
      <i class="icon icon--check-green-size50"></i>
      <p class="title">{{ $t('account.resetPassword.done.title') }}</p>
      <p class="desc" v-html="$t('account.resetPassword.done.desc')"></p>
      <UiButton class="btn__confirm" @click="onCloseLayer">
        {{ $t('common.confirm') }}
      </UiButton>
    </div>
  </content-box>
</template>

<script>
import { resetPassword } from '@/api/user'
import UiButton from '@/components/ui/UiButton'
import ContentBox from '@/components/ui/ContentBox'

export default {
  components: {
    UiButton,
    ContentBox
  },
  props: [
    'authParam'
  ],
  data () {
    return {
      model: {
        key: '',
        userPw: ''
      },
      modelError: {
        userPw: ''
      },
      isDoneResetPassword: false,
      toggleInputType: true
    }
  },
  methods: {
    toggleShowPasswordValue () {
      const targetElement = document.querySelector('#resetPassword')
      if (targetElement.attributes.type.value === 'password') {
        targetElement.setAttribute('type', 'text')
        this.toggleInputType = false
      } else {
        targetElement.setAttribute('type', 'password')
        this.toggleInputType = true
      }
    },
    onSubmit () {
      this.model.key = this.authParam.value
      if (!this.model.userPw.length) {
        this.modelError.userPw = 'requiredPassword'
        return false
      } else if (this.model.userPw.length < 6) {
        this.modelError.userPw = 'passwordInsufficient'
        return false
      }
      resetPassword(this.model).then(() => {
        this.isDoneResetPassword = true
      }).catch(err => {
        if (err.message === 'Invalid params') this.modelError.userPw = 'invalidParams'
        if (err.message === 'User not found') this.modelError.userPw = 'userNotFound'
        if (err.message === 'Key expired') this.modelError.userPw = 'resetPasswordKeyExpired'
      })
    },
    onCloseLayer () {
      this.$emit('closeLayer')
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.popup__content {
  @include positionXYcenter;
  padding: 30px;

  &.is-done,
  &.error {
    padding: 50px 25px 25px;
  }

  .auth-success {
    text-align: center;
    .icon--reset-password {
      margin-top: 20px;
    }
    .title {
      display: block;
      margin-top: 15px;
      font-size: 20px;
      line-height: 23px;
      color: #444;
    }
    .input--wrap {
      position: relative;
      margin-top: 25px;
      width: 100%;

      fieldset {
        position: relative;
      }

      .validation-text {
        @include validErrorText;
        position: absolute;
        left: 6px;
        bottom: -20px;
      }

      .label {
        display: block;
        text-align: left;
        font-size: 13px;
        font-weight: bold;
        color: #767676;
        padding-left: 6px;
      }

      #resetPassword {
        font-size: 14px;
        margin-top: 5px;
        width: 100%;
        height: 38px;
        border-radius: 6px;
        border: solid 1px #bbbbbb;
        background-color: #ffffff;
        box-sizing: border-box;
        padding: 12px;
        padding-right: 35px;
      }

      .icon--pw-eye {
        position: absolute;
        top: 19px;
        right: 5px;
        padding: 5px;
      }

      .btn--wrap {
        margin-top: 40px;

        .btn__confirm {
          margin-left: 5px;
        }
      }
    }
  }

  .auth-fail,
  .reset-password__done {
    text-align: center;

    .title {
      margin-top: 15px;
      font-size: 20px;
      font-weight: bold;
      line-height: 1;
      text-align: center;
      color: #444444;
    }
    .desc {
      margin-top: 12px;
      font-size: 14px;
      line-height: 1.43;
      color: #2f2f2f;
    }
    .btn__confirm {
      margin-top: 50px;
    }
  }
}
</style>
